import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RenderIf } from 'syf-component-library/ui/atoms';
import useTranslation from '../../../hooks/use-translation';
import { StyledFlex } from '../../../styles/common';
import transactionIconTypes from '../icons/transaction-type-icons';
import { StyledIconContainer, StyledIconText } from './subcomponents';
// This function normalizes the transactionType so that we can match them with our translation file
const getTransactionTypeTranslationKey = (transactionType) => {
    if (transactionType === 'CASH_ADVANCE')
        return 'cashAdvance';
    if (transactionType === 'LATE_FEE')
        return 'lateFee';
    return (transactionType.charAt(0).toLowerCase() +
        transactionType.toLowerCase().slice(1));
};
const TransactionIcon = ({ badge, transactionType }) => {
    const t = useTranslation();
    const translatedType = t(`transactionTypes.${getTransactionTypeTranslationKey(transactionType)}`);
    return (_jsxs(StyledFlex, { direction: "column", alignItems: "center", children: [_jsx(StyledIconContainer, { badge: badge, direction: "column", justifyContent: "center", children: transactionIconTypes[transactionType.toUpperCase()] }), _jsx(RenderIf, { condition: !badge, children: _jsx(StyledIconText, { as: "span", color: "cyanBlue", weight: "semiBold", children: translatedType }) })] }));
};
export default TransactionIcon;
//# sourceMappingURL=index.js.map